export default __webpack_public_path__ + "static/IAPMEI-659b0ab5d2b04764cfc8169debdb914b.svg";